import { render, staticRenderFns } from "./OfferEditPriceIndicationEmail.vue?vue&type=template&id=0289b014"
import script from "./OfferEditPriceIndicationEmail.vue?vue&type=script&lang=js"
export * from "./OfferEditPriceIndicationEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports